import { FC, ReactNode } from 'react';
import { Box, BoxProps, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { QcsFloatingPillButton } from './QcsFloatingPillButton';

type ContentProps = BoxProps & { [dataAttr: `data-${string}`]: unknown };

interface Props {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  contentProps?: ContentProps;
  disablePadding?: boolean;
}

export const QcsFullscreenModal: FC<Props> = ({ open, onClose, children, contentProps, disablePadding }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          p: disablePadding ? 0 : 3,
        }}
      >
        <Box
          sx={{
            position: 'fixed',
            top: 12,
            right: 12,
            zIndex: (theme) => theme.zIndex.modal + 1,
            opacity: 0.4,
            transition: 'opacity 0.25s ease-in-out',
            '&:hover, &:focus-within': { opacity: 1 },
          }}
        >
          <QcsFloatingPillButton icon={<CloseIcon />} labelKey="common.close" onClick={onClose} />
        </Box>
        <Box
          {...contentProps}
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            ...contentProps?.sx,
          }}
        >
          {children}
        </Box>
      </Box>
    </Modal>
  );
};
